// Routes
// WARNING: These paths are hardcoded and need to match the back-end

// IDs are only ever interpolated into a path string, so they may arrive as either a
// string (e.g. a patient logicalId or parsys UUID) or a number (e.g. a numeric row id).
type RouteId = string | number;

export const CALENDAR_PATH = '/calendar/';
export const UPCOMING_APPOINTMENTS_PATH = '/calendar/appointments/';
export const PATIENT_APPOINTMENT_CREATION_PATH = '/calendar/patient/create/';
export const CALENDAR_USER_SETTINGS_PATH = '/calendar/user/settings/';

export const API_PATIENT_PATH = '/api/patients/';
export const API_PATIENT_UNIQUE_PATH = `${API_PATIENT_PATH}unique/`;
export const API_PATIENT_CREATE_PATH = `${API_PATIENT_PATH}create/`;
export const getApiPatientUpdatePath = (logicalId: RouteId) => `${API_PATIENT_PATH}${logicalId}/update/`;
export const getApiPatientFollowUpPath = (patientId: RouteId) => `${API_PATIENT_PATH}${patientId}/medical-follow-up/`;
export const PATIENT_PATH = '/patients/';
export const PATIENT_CREATE_PATH = `${PATIENT_PATH}create/`;
export const getPatientPath = (logicalId: RouteId) => `${PATIENT_PATH}${logicalId}/`;
export const getPatientUpdatePath = (logicalId: RouteId) => `${PATIENT_PATH}${logicalId}/update/`;

export const DEFAULT_AVATAR_PATH = '/static/images/user-default.png';
const PATIENT_AVATAR_PATH = '/images/';
export const getPatientAvatarPath = (avatarUrl: string) => `${PATIENT_AVATAR_PATH}${avatarUrl}`;

const AREA_FIELD_IMAGE_PATH = '/static/images/areafields/';
export const getAreaFieldImagePath = (name: string) => `${AREA_FIELD_IMAGE_PATH}${name}/`;

export const API_AVAILABILITY_PATH = '/api/schedules/';
export const getApiAvailabilityPath = (scheduleId: RouteId) => `${API_AVAILABILITY_PATH}${scheduleId}`;
export const getApiAvailabilityRecurrencePath = (scheduleId: RouteId) => `${API_AVAILABILITY_PATH}${scheduleId}/recurrence/`;

export const API_APPOINTMENT_PATH = '/api/appointments/';
export const getApiAppointmentPath = (appointmentId: RouteId) => `${API_APPOINTMENT_PATH}${appointmentId}`;

export const API_SLOT_PATH = '/api/slots/';
export const getApiSlotLocationPath = (location_id: RouteId) => `${API_SLOT_PATH}for-location/${location_id}`;

export const API_LOCAL_SETTINGS_PATH = '/api/local-settings/';

export const API_USERS_PATH = '/api/users/';
export const API_WORKFLOW_PATH = '/api/workflows/';

// Consultation routes exist in two shapes: the canonical parsys_id one and the deprecated patient/consultation id
// one (see views/consultations/includeme.py). `params` comes from extractConsultationParamsFromUrl.
type ConsultationParams = {
  parsysId?: string;
  patientId?: RouteId;
  consultationId?: RouteId;
}

const getConsultationBasePath = ({ parsysId, patientId, consultationId }: ConsultationParams, prefix = '') => {
  if (parsysId) {
    return `${prefix}/consultations/${parsysId}`;
  }
  if (patientId == null || consultationId == null) {
    // Fail loudly rather than interpolating "undefined" into a path that then 404s with no clue why.
    throw new Error(`Cannot build a consultation path: no parsys_id or patient/consultation id in ${window.location.href}`);
  }
  return `${prefix}/patients/${patientId}/consultations/${consultationId}`;
};
export const getConsultationPath = (params: ConsultationParams) => `${getConsultationBasePath(params, '/api')}/`;
export const getConsultationEventsPath = (params: ConsultationParams) => `${getConsultationBasePath(params)}/events/`;
export const getConsultationTransitionPath = (params: ConsultationParams, transitionName: string) => `${getConsultationBasePath(params)}/${transitionName}/`;

export const API_CONSULTATION_CODES_PATH = '/api/consultation-codes';

export const API_SMUR_TEAMS = '/api/live-location/';

export const API_RESOURCES = '/api/calendar/services';

export const API_LOCATION = '/api/calendar/locations/';

export const API_LOCATION_WITH_SLOTS = `${API_LOCATION}with-slots/`;

export const API_SIGN_UP = '/api/user-patient/';
export const API_PASSWORD_VALIDATE = '/api/password/validate';
